export enum MessageScopes {
    Arbetsorder = 1,
    SenasteHandelser = 2,
    Virkeskop = 4,
    PagaendeAffarer = 8,
    Skogsvard = 16,
    Avverkning = 32
}
